import * as React from 'react';
import type { SVGProps } from 'react';
const SvgError = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
        <path
            fill="#DF002D"
            fillRule="evenodd"
            d="M15.429 0A2.574 2.574 0 0 1 18 2.571V15.43A2.574 2.574 0 0 1 15.429 18H2.57A2.574 2.574 0 0 1 0 15.429V2.57A2.574 2.574 0 0 1 2.571 0zM9.025 11.5a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75m0-7a.874.874 0 0 0-.875.875V9.75a.874.874 0 1 0 1.75 0V5.375a.875.875 0 0 0-.875-.875"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgError;
